import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import {
  clearBookingDetails,
  getBookingDetails,
} from "redux/actions/ReservationAction";
import { formatCurrency, getDateComparision, getDateFormat, optionsList } from "utils/utils";
import CommonButton from "components/commonButton/CommonButton";
import BackDrop from "components/backDrop/BackDrop";
import { bookingDetailsData, bookingTime, cancelDialogMenu } from "./FrontDeskData";
import CommonTableDialog from "components/commonTableDialog/CommonTableDialog";
import WaterBottle from "assets/images/WaterBottle.svg";
import Wifi from "assets/images/Wifi.svg";
import Snack from "assets/images/Snack.svg";
import Charger from "assets/images/Charger.svg";
import NewsPaper from "assets/images/NewsPaper.svg";
import Loader from "components/loader/Loader";

const FrontDeskBookingDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const defaultStatus = ["booked", "alloted","pending"];

  const bookingDetails = useSelector(
    (state) => state?.getBookingDetails?.bookingDetails
  );
  const bookingDetailsLoading = useSelector(
    (state) => state?.getBookingDetails?.loading
  );

  const CabFacilities = bookingDetails?.facilities;
  const details = optionsList(bookingDetails);
  const status = bookingDetails?.status?.toLowerCase();

  useEffect(() => {
    dispatch(getBookingDetails(location?.state?.id));
    return () => {
      dispatch(clearBookingDetails());
    };
  }, []);

  // ---For Image Error---
  const handleOnError = (e, facilityName) => {
    let replacementImage;
    switch (facilityName) {
      case "Wifi":
        replacementImage = Wifi;
        break;
      case "Snack":
        replacementImage = Snack;
        break;
      case "Charger":
        replacementImage = Charger;
        break;
      case "News Paper":
        replacementImage = NewsPaper;
        break;
      case "Water Bottel":
        replacementImage = WaterBottle;
        break;
      default:
        replacementImage = Wifi;
    }
    e.target.src = replacementImage;
  };

  const filterValue = (key) => {

    const keys = ["Rep. Address", "Drop Address", "Via Address", "Landmark", "Special Instruction", "Trip Charges", "Flight No","Cancellation Reason"]

    if (key === "Special Instruction" && bookingDetails?.DriverProfile) {
      return "";
    } else if (keys.includes(key)) {
      return "expandRow";
    }
  };

  const handleEdit = (bookingDetails) => {
    const dateStatus = getDateComparision(bookingDetails?.scheduledTime);
    if (dateStatus) {
      navigate("/front-desk/new-booking", {
        state: { id: bookingDetails?.id, page: "edit" },
      });
    }
  };

  const handleDialog = (event) => {
    setOpen(event.currentTarget);
  };

  return (
    <>
      {bookingDetailsLoading ? (
        <Loader height={"80vh"} />
      ) : (
        <Box className="bookingDetails">
          <Grid
            container
            className="pb20"
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Box display={"flex"} alignItems={"center"}>
              <ArrowBackIosRoundedIcon
                className="font24 colorGrey"
                role="presentation"
                onClick={() => navigate(-1)}
              />
              <Typography variant={"head4"} className="colorPrimary pl10">
                Booking ID {bookingDetails?.tripId}
              </Typography>
            </Box>
            {defaultStatus?.includes(status) && (
              <CommonButton
                name={"Edit"}
                iconType={"edit"}
                iconPlace="front"
                btnClass={`btnSm btnEdit`}
                disabled={!getDateComparision(bookingDetails?.scheduledTime)}
                onClick={() => handleEdit(bookingDetails, "edit")}
              />
            )}
          </Grid>
          <Box className="dashedBorderBottom"></Box>
          <Grid container justifyContent={"center"}>
            <Grid item xs={11}>
              <Grid
                container
                className="ptb30"
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Typography variant={"head5"} className="fw600 colorBlack">
                  Booking Details&nbsp;
                  <span className="font14 fw400">
                    ({getDateFormat(bookingDetails?.updatedAt, "fromNowFormat")}
                    )
                  </span>
                </Typography>
                {defaultStatus?.includes(status) &&
                  <IconButton
                  aria-label="open drawer"
                  edge="start"
                  onClick={(event) => handleDialog(event)}
                  className="pl25"
                >
                  <MoreVertIcon />
                </IconButton>
                }
                {status === "completed" && (
                  <Typography variant={"head5"} className="colorPrimary fw600">
                    Total Trip Charges - ₹&nbsp;
                    {formatCurrency(bookingDetails?.price)}
                  </Typography>
                )}
              </Grid>

              <Grid container className="ptb20 bgLightYellow">
                {bookingTime(bookingDetails, details)?.map((data, index) => (
                  <Grid
                    key={index}
                    item
                    xs={12}
                    sm={3}
                    sx={{
                      padding: { xs: "20px 0px 0px 20px", sm: "0px" },
                      justifyContent: { xs: "flex-start", sm: "center" },
                    }}
                    container
                    className="justifyCenter"
                  >
                    <Box className="flexDisplay">
                      <img src={data.img} alt="Logo" />
                    </Box>
                    <Typography className="colorBlack font16 pl20">
                      {data.title || "NA"}
                    </Typography>
                  </Grid>
                ))}
              </Grid>

              <Grid container className="mt40 mb20">
                {bookingDetailsData(bookingDetails, details)?.map(
                  (value, key) => (
                    <Grid
                      key={key}
                      item
                      xs={12}
                      md={filterValue(value?.title, value?.status) ? 12 : 6}
                      sx={{ display: value?.title ? "flex" : "none" }}
                      container
                    >
                      <Grid
                       xs={4}
                        md={filterValue(value?.title, value?.status) ? 2 : 4}
                        item
                        className="p20 justifyStart gridBorder"
                      >
                        <Typography variant={"body2"} className="colorGrey">
                          {value.title || "NA"}
                        </Typography>
                      </Grid>

                      <Grid
                        item
                        xs={8}
                        md={filterValue(value?.title, value?.status) ? 10 : 8}
                        flexWrap={"wrap"}
                        className="p20 justifyStart gridBorder"
                      >
                        <Typography
                        component={"span"}
                          variant={`${
                            value?.textType === "textBold" ? "head5" : "body2"
                          }`}
                          className={`pr10 ${
                            value?.textType === "textBold" && "fw700"
                          } justifyStart`}
                        >
                          {value.data || "NA"}&nbsp;&nbsp;
                          </Typography>
                          {value?.exclusive && (
                          <Typography variant={"body3"} component={"span"} className={"colorGrey"}>
                          (Exclusive of GST and Toll & Parking)
                          </Typography>
                        )}
                       
                        {value.title === "Passenger Name" && value.isVip && (
                          <Typography variant={"body5"} className="vipBadge">
                            VIP
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  )
                )}
              </Grid>
              {status === "completed" ? (
                <img
                  src={bookingDetails?.tripRouteImage?.url}
                  alt="map"
                  className="width100 height400"
                />
              ) : (
              <>
                <Typography
                  variant="head5"
                  component={"h2"}
                  className="colorBlack fw600 mb20"
                >
                  Facilities
                </Typography>
                <Grid container className="mt20 mb20">
                  {CabFacilities?.length ? (
                    CabFacilities?.map((row, index) => (
                      <Grid
                        item
                        md={2.4}
                        sm={6}
                        xs={12}
                        key={index}
                        className="facilityDashedBorder"
                      >
                        <Box className="justifyCenter ptb20">
                          <Box display={"flex"} alignItems={"center"}>
                            <img
                              src={row?.img?.url}
                              alt="Logo"
                              className="width40 height40 objectFit"
                              onError={(e) => handleOnError(e, row?.name)}
                            />
                          </Box>
                          <Typography className="colorGrey font16 pl20">
                            {row?.name || "NA"}
                          </Typography>
                        </Box>
                      </Grid>
                    ))
                  ) : (
                    <Typography className="colorGrey">
                      No Facilites Available
                    </Typography>
                  )}
                </Grid>
              </>
              )}
            </Grid>
          </Grid>
          {(status === "booked" ||
            status === "alloted" ||
            status === "dispatched") && (
            <Grid className="colorGrey font18 mb30 justifyCenter" container>
              <Grid item xs={11}>
                <Typography className="fw600 font20 colorBlack">
                  Cancellation Note
                </Typography>
                <li>
                  There will be no cancellation charge if the trip is cancelled
                  before 2 hours of the scheduled time.
                </li>
                <li>
                  There will be minimum cancellation charge if the trip is
                  cancelled after 2 hours of the scheduled time.
                </li>
              </Grid>
            </Grid>
          )}
        </Box>
      )}

        <CommonTableDialog
            menuData={cancelDialogMenu}
            open={open}
            setOpen={setOpen}
            data={bookingDetails}
          />
    </>
  );
};

export default FrontDeskBookingDetails;
